module.exports = __webpack_public_path__ + "static/apheris AI-c696bf82922bc5cf673e868e515fceee.jpg";